import React from 'react';
import { Alert, Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const NewCase = ({ newCase }) => (
  <Alert.success mb="0" data-testid="NEW_CASE_ALERT">
    <Box>
      <strong>Your enquiry has been sent</strong>
      <br />
      Thank your for your enquiry. One of our customer service representatives
      will be in touch soon.
      <br />
      {`Your support reference is ${newCase.caseNumber}`}
    </Box>
  </Alert.success>
);

NewCase.propTypes = {
  newCase: PropTypes.shape({
    caseNumber: PropTypes.string,
  }).isRequired,
};

export default NewCase;
